import client from "../../api/client";
import { AxiosError } from "axios";
import { getAuth } from "firebase/auth";
import { GetMyCommentsResponse } from "../../api/board_comment";

type TApiFetchMyBoardComment = {
  board_id: number;
};

export type TApiAllMyCommentsResult = {
  result?: GetMyCommentsResponse;
};

export const fetchMyBoardComments = async ({
  board_id,
}: TApiFetchMyBoardComment): Promise<GetMyCommentsResponse> => {
  const query = {
    query: { board_id },
  };

  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  const authHeader = { headers: { Authorization: `Bearer ${token}` } };
  return await client()
    .board_comment.getMyComments({ ...query, ...authHeader })
    .then((res) => {
      return res.body;
    })
    .catch((e: AxiosError) => {
      return {
        data: [],
      };
    });
};
